/**
 * F13.5-A — CÓDIGO DE NEGOCIO (lo que ve el usuario)
 *
 * Tres capas: uuid (técnica) ≠ token NeatOS (ART-… / ALM-…) ≠ código de
 * negocio. En la interfaz se muestra SIEMPRE el código de negocio que manda
 * el servidor (`codigoNegocio`: el del sistema maestro o, si no hay, el
 * token). El token no se enseña por defecto: vive en «Detalles técnicos»,
 * etiquetas, auditoría y soporte. Ninguna regla se repite aquí: si el servidor
 * no manda `codigoNegocio` (respuestas antiguas, snapshots), se usa `codigo`.
 * Los snapshots históricos (inventarios, previstos) siguen mostrando el código
 * que se congeló entonces: este componente no los reescribe.
 */
import type { ReactNode } from 'react';

export interface ConCodigoVisible {
  /** Token NeatOS (ART-…, ALM-…). */
  readonly codigo: string;
  readonly codigoNegocio?: string | undefined;
}

/** Texto plano del código visible (para títulos, migas, aria-label, mensajes). */
export function codigoVisible(a: ConCodigoVisible): string {
  return a.codigoNegocio ?? a.codigo;
}
/** Lo mismo para un almacén (FUR-MNT-01 en vez de ALM-000003). */
export const codigoAlmacen = codigoVisible;

export function CodigoArticulo({ articulo: a }: { articulo: ConCodigoVisible; enLinea?: boolean }): ReactNode {
  return <span className="mono">{codigoVisible(a)}</span>;
}

/** Token NeatOS plegado: para soporte, etiquetas y auditoría (nunca a la vista por defecto). */
export function DetallesTecnicos({ token, sistema, children }: { token: string; sistema?: string | null; children?: ReactNode }): ReactNode {
  return (
    <details className="detalles-tecnicos">
      <summary>Detalles técnicos</summary>
      <dl className="pequena">
        <dt>Código NeatOS (etiquetas y soporte)</dt>
        <dd className="mono">{token}</dd>
        {sistema !== undefined && <><dt>Origen del código</dt><dd>{sistema === null ? 'NeatOS (sin sistema maestro)' : sistema}</dd></>}
      </dl>
      {children}
    </details>
  );
}
